<template>
  <div>
    <h3 class="profile-title">{{$tr('profile.title')}}</h3>
    <div class="profile-container">
      <div class="left-panel">
        <div class="settings-company__dragDrop" :class="{ 'has-files': hasFiles }">
          <input type="file"
                  name="file"
                  id="file"
                  @change="logoChange($event.target.files)"
                  accept="image/*"
                  class="settings-company__dragDrop-input">
          <div v-if="isDefaultFile && !deleteFile" class="upload__image">
            <img v-if="userLogo" :src="userLogo" />
          </div>
          <div v-if="imgLink && !isDefaultFile" class="upload__image">
            <img v-if="imgLink" :src="imgLink" />
          </div>
          <div class="upload__description">
            <div class="settings-company__dragDrop-subtitle">
              <div class="dragDrop-descr" v-if="!hasFiles">
                <icon-upload width="24px" height="15px" fill="#00d26e" />
                <div class="dragDrop-descr_title">{{$tr('profile.profileForm.logo.title')}}</div>
                <div class="dragDrop-descr_note">{{$tr('profile.profileForm.logo.description')}}</div>
              </div>
              <span v-else>
                <icon-upload :width="'24px'" :height="'15px'" :fill="'#fff'"/>
                {{ $tr('settings.company.labels.uploadNewLogo') }}
              </span>
            </div>
          </div>
        </div>
        <label class="helper" v-if="errorsAtLogo.show">{{ errorsAtLogo.message }}</label>
      </div>

      <div class="right-panel">
        <form class="form-horizontal my-profile-form">
          <h3>{{ $tr('profile.profileForm.info.title') }}</h3>

          <div class="row-block" data-test-id="profile-user-name">
            <template v-if="!is_japan_locale">
              <label>{{ $tr('profile.profileForm.info.name') }}</label>
              <vinput
                v-model.lazy="user.name"
                class="width"
                :border="true"
                :error="(ierrors.name) ? ierrors.name[0] : ''"
                @input="set_change(true)"
              />
            </template>
            <template v-else>
              <label>{{ $tr('profile.profileForm.info.surname') }}</label>
              <vinput
                v-model.lazy="user.surname"
                class="width"
                :border="true"
                :error="(ierrors.surname) ? ierrors.surname[0] : ''"
                @input="set_change(true)"
              />
            </template>
          </div>
          <div class="row-block" data-test-id="profile-user-surname">
            <template v-if="!is_japan_locale">
              <label>{{ $tr('profile.profileForm.info.surname') }}</label>
              <vinput
                v-model.lazy="user.surname"
                class="width"
                :border="true"
                :error="(ierrors.surname) ? ierrors.surname[0] : ''"
                @input="set_change(true)"
              />
            </template>
            <template v-else>
              <label>{{ $tr('profile.profileForm.info.name') }}</label>
              <vinput
                v-model.lazy="user.name"
                class="width"
                :border="true"
                :error="(ierrors.name) ? ierrors.name[0] : ''"
                @input="set_change(true)"
              />
            </template>
          </div>

          <div
            class="row-block"
            data-test-id="profile-user-position"
          >
            <label>{{ $tr('profile.profileForm.info.position') }}</label>
            <vinput
              v-model.lazy="user.position"
              class="width"
              :border="true"
              :error="(ierrors.position) ? ierrors.position[0] : ''"
              @input="set_change(true)"
            />
          </div>

          <div class="row-block" data-test-id="profile-user-geo">
            <label>{{ $tr('profile.profileForm.info.city') }}</label>
            <CitySelect
              :selectedGeo="user.geo"
              :getAddressData="getAddressData"
              :deleteGeo="deleteGeo"
              :error="(ierrors.geo) ? ierrors.geo[0] : ''"
            />
          </div>

          <h3>{{ $tr('profile.profileForm.contacts.title') }}</h3>

          <div class="row-block" data-test-id="profile-user-email">
            <label>{{ $tr('profile.profileForm.contacts.email') }}</label>
            <vinput
              v-model.lazy="user.new_email"
              class="width"
              :border="true"
              :error="(ierrors.new_email) ? ierrors.new_email[0] : ''"
              :hasError="!isEmailValid"
              @input="set_change(true)"
              @setValid="set_valid"
              name="email"
              id="email"
              validate="required|email"
            />
          </div>
          <div class="row-block" data-test-id="profile-user-phone">
            <label>{{ $tr('profile.profileForm.contacts.phone') }}</label>
            <vphone
              class="width"
              v-model.lazy="user.phone"
              :border="true"
              :error="(ierrors.phone) ? ierrors.phone[0] : ''"
              @input="set_change(true)"
            />
          </div>

          <div class="row-block" data-test-id="profile-user-skype">
            <label>{{ $tr('profile.profileForm.contacts.skype') }}</label>
            <vinput
              class="width"
              v-model.lazy="user.skype"
              :border="true"
              @input="set_change(true)"
              />
          </div>



          <h3>{{ $tr('profile.profileForm.settings.title') }}</h3>

          <div class="row-block" data-test-id="profile-user-locale">
            <label>{{ $tr('profile.profileForm.settings.locale') }}</label>
            <SimpleSelect
              class="city-select_custom boxy"
              :value="locale"
              :options="localeOptions"
              :onChange="onLocaleChange"
              :allowEmpty="false"
            />
          </div>
          <div class="row-block_btn">
            <vbutton
              label="common.save"
              :disabled="!isEmailValid || !user || !user.new_email || !user.new_email.length"
              @click="save"
            />
          </div>
        </form>
        <!-- Только в России показываем блок экспресса hh и sj -->
        <div class="expressInvite" v-if="show_hh_sj" data-test-id="profile-express-invite">
          <a class="expressInvite__link" :href="widgetUrl">
            {{ $tr('profile.expressInvite.button') }}
          </a>
          <div class="expressInvite__info">
            {{ $tr('profile.expressInvite.info') }}
          </div>
        </div>
        <!-- конец hh sj -->
      </div>
    </div>

    <transition name="modal">
      <div class="modal-mask" v-show="showCropModal">
        <div class="modal-wrapper">
          <div class="modal-container">
            <a class="modal-close" @click="closeCropModal"></a>
            <div class="modal-header">
              {{$tr('profile.modalCrop.modalTitle')}}
              <!-- Выбор области изображения -->
            </div>
            <div class="modal-body">
              <vue-cropper
                  ref='cropper'
                  :guides="true"
                  :view-mode="2"
                  :autoCropArea="1"
                  :min-container-width="300"
                  :min-container-height="300"
                  :background="true"
                  :rotatable="true"
                  :aspectRatio="1"
                  alt="Source Image"
                  :container-style="{ display: 'flex', justifyContent: 'center' }"
                  :img-style="{ width: '400px', height: '400px', margin: '0 auto' }"
              />
            </div>
            <div class="modal-footer" data-test-id="profile-modal-image">
              <vbutton class="left"
                label="profile.modalCrop.closeBtn"
                @click="closeCropModal" />
              <vbutton
                label="profile.modalCrop.rotateBtn"
                @click="rotate90Angle" />
              <vbutton
                label="profile.modalCrop.saveBtn"
                @click="uploadImage" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getCountryCallingCode } from 'libphonenumber-js'
import CitySelect from '@/components/shared/CitySelect.vue'
import SimpleSelect from '@/components/shared/SimpleSelect.vue'
import VueCropper from 'vue-cropperjs'
import ModalAlert from '@/components/modals/ModalAlert.vue'
import { getCountryCodeFromPlaceID } from '@/components/invites/creation/CORSrequest.js'
import { get_address } from '@/_helpers/utils'

import expressButton from './express_button.js'

// import UserApi from '@/api/user.js'

const IMAGE_MAX_SIZE_BYTES = 5 * 1024 * 1024

const getInitialState = () => {
  return {
    showCropModal: false,
    newEmail: '',
    cropImg: '',
    errorsAtLogo: {
      show: false,
      message: ''
    },
    fileList: null,
    imgLink: null,
    deleteFile: false,
  }
}
export default {
  name: 'default',
  components: {
    CitySelect,
    SimpleSelect,
    VueCropper,
    ModalAlert
  },

  mixins: [ expressButton ],

  data () {
    return Object.assign({
      user: {
        name: '',
        email: '',
        new_email: '',
        phone: '',
        company: null,
        geo: {
          place_id: null,
          description: null
        },
        position: '',
        skype: ''
      },
      phoneMask: '',
      updatedPhone: '',
      userPhone: null,
      validPhone: false,
      errorClass: '',
      errorRequiredClass: '',
      userCountry: '',
      passConfirmHasBeenTouched: false,
      selectedLocale: '',
      isEmailValid: true
    }, getInitialState())
  },

  watch: {
    stateUser (val) {
      this.resetValues()
    },

    cropImg (val) {
      if (val) {
        this.cropSuccess();
        this.set_change(true);
      }
    },

    placeId (val) {
      if (val && !this.userPhone) {
        this.geoRequest(val)
        this.set_change(true);
      }
    },

    disableSaveButton (newVal) {
      this.$emit('changeSaveButton', newVal)
    }
  },

  computed: {
    ...mapState('process', ['companyCommonSpecialProcess']),

    ...mapState('process/sportmaster/User', ['userInfo']),

    userLogo () {
      return this.user ? this.user.logo : null
    },

    isDefaultFile () {
      if (this.userLogo && !this.fileList) {
        return true
      }

      return false
    },

    hasFiles () {
        if (this.deleteFile) {
            return false;
        }
        return this.fileList || this.isDefaultFile
    },

    show_hh_sj() {
      return this.user.company && this.user.company.country && this.user.company.country.code === 'RU';
    },
    ierrors() {
      let errors = (this.error && this.error.details) ? this.error.details : '';
      return errors;
    },
    disableSaveButton () {
      return !this.canBeSaved && !this.selectedLocale
    },

    placeId () {
      const geo = this.user ? this.user.geo : null

      return geo ? geo.place_id : null
    },

    canBeSaved () {
      const fields = Object.keys(this.fields).map(k => this.fields[k])
      const isPhoneValid = this.userPhone ? this.validPhone : false

      return fields.every(f => f.valid === true) && this.placeId && isPhoneValid
    },

    modal() {
      return this.$store.getters['user/modal_alert'];
    },

    modalShow () {
      return this.modal ? this.modal.show : null
    },

    modalType () {
      const options = this.modal ? this.modal.options : null

      return options ? options.type : ''
    },

    modalTextBody () {
      const options = this.modal ? this.modal.options : null

      return options ? this.$tr(options.bodyKey) : ''
    },

    localeOptions () {
      return this.$store.state.locale.available
    },

    currentLocale () {
      return this.$store.state.locale.value
    },

    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },

    stateUser () {
      return this.$store.getters['user/current']
    },

    error () {
      return this.$store.getters['user/error']
    },

    errorDetails () {
      return this.$store.getters['user/error'] ? this.$store.getters['user/error'].details : null
    },

    locale: {
      get () {
        if (this.selectedLocale) {
          return this.localeOptions.find(l => l.value === this.selectedLocale)
        }

        return this.localeOptions.find(l => l.value === this.currentLocale)
      },

      set ({ value }) {
        this.selectedLocale = value
      }
    },

    widgetUrl () {
      return this.getExpressLink(window.location.origin + '/')
    }
  },

  methods: {
    changePhone (phone) {
      this.updatedPhone = phone
    },

    set_valid(val) {
      this.isEmailValid = val;
    },

    geoRequest (placeId) {
      const locale = this.currentLocale;
      getCountryCodeFromPlaceID(placeId, locale)
        .then(res => {
          this.userCountry = res
        })
        .catch(err => { console.log(err) })
    },

    clearModalAlertData () {
      this.$store.dispatch('user/clearModalAlertData')
    },

    uploadImage () {
      const canvas = this.$refs.cropper.getCroppedCanvas()

      if (canvas.msToBlob) {
        this.cropImg = canvas.msToBlob()
      } else {
        canvas.toBlob(res => {
          this.cropImg = res
        }, 'image/jpeg')
      }
    },

    logoChange (fileList) {
      if (!fileList.length) {
        return
      }
      this.fileList = fileList;

      if (!this.fileList[0].type.includes('image/')) {
        this.errorsAtLogo.message = this.$tr('profile.profileForm.photoSelector.format')
        this.errorsAtLogo.show = true
        return
      }

      const file = this.fileList[0];
      this.deleteFile = false;

      if (file.size / IMAGE_MAX_SIZE_BYTES >= 1) {
        this.errorsAtLogo.message = this.$tr('profile.profileForm.photoSelector.tooLarge')
        this.errorsAtLogo.show = true
        return
      }

      if (typeof FileReader === 'function') {
        this.toggleCropModal()
        const reader = new FileReader()

        reader.onload = (event) => {
          this.imgLink = event.target.result
          this.$refs.cropper.replace(event.target.result)
        }

        reader.readAsDataURL(file)
      } else {
        this.errorsAtLogo.message = this.$tr('profile.profileForm.photoSelector.dontSupport')
        this.errorsAtLogo.show = true
      }
    },

    rotate90Angle () {
      this.$refs.cropper.rotate(90)
    },

    toggleCropModal () {
      this.showCropModal = !this.showCropModal
    },

    closeCropModal () {
      this.toggleCropModal()
      this.resetValues()
      this.$refs.fileSelector.value = ''
    },

    onLocaleChange(locale) {
      this.locale = locale;
      this.set_change(true);
    },

    getAddressData(addressData, placeResultData) {
      this.user.geo = get_address(addressData, placeResultData);
      this.set_change(true);
    },

    deleteGeo () {
      this.user.geo = {
        place_id: null,
        description: null
      }
    },

    resetValues () {
      const state = getInitialState()

      for (let k in state) {
        this[k] = state[k]
      }
      this.user = { ...this.stateUser }
      if (!this.user.geo) {
        this.deleteGeo()
      }
      if(this.user.phone === null || this.user.phone === '') {
        this.user.phone = '+' + getCountryCallingCode(this.stateUser.country.code)
      }
      if (this.user && this.user.phone && !this.userPhone) {
        this.userPhone = this.user.phone;
      }
    },

    save () {
      const param = Object.assign({}, {
        ...this.user,
        new_email: this.user.new_email,
        language: {
          code: this.locale.value
        }
      })
      this.set_change(false);

      this.$store.dispatch('user/save', param).then((data) => {
        if (this.selectedLocale && this.currentLocale !== this.selectedLocale && !this.error) {
          this.setLocale(this.selectedLocale)
        }
        if (this.error) {
          this.$noty.error(this.error.message); // this.$tr('profile.info.save_error')
        } else {
          this.$noty.success(this.$tr('profile.info.save_success'))
        }
      }).catch(e => {
        if(e.status === 400) {
          this.$noty.error(this.error.message); // this.$tr('profile.info.save_error')
        } else {
          this.$noty.error(this.$tr('common.error.networkError'));
        }
      });
    },

    setLocale (value) {
      this.$store.dispatch('locale/change', value)
      setTimeout(() => {
        window.location.reload()
      }, 100)
    },

    cropSuccess () {
      this.$store.dispatch('user/saveUserLogoRequest', {
        email: this.user.email,
        logo: this.cropImg
      })
    },

    set_change(val) {
      this.$store.commit('user/set_change_user', val);
    }
  },

  beforeMount () {
    this.user.phone = this.stateUser.phone;
    this.resetValues()

    // this is moved from beforeRouteEnter
    if (!this.stateUser || !this.stateUser.id) {
      this.$store.dispatch(
        'user/userInfoRequest',
        this.$store.getters['user/accessToken'].user.email
      )
    }
    if (this.placeId) {
      this.geoRequest(this.placeId)
    }

    this.$emit('changeSaveButton', this.disableSaveButton)
  },

  mounted () {
    this.$parent.$parent.$parent.$on('save', this.save)
  },

  beforeDestroy () {
    this.$parent.$parent.$parent.$off('save')
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/variables.scss';

.profile-title {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: #233346;
  margin-bottom: 1rem;
  padding: 0;
}
.width {
  width: 100%;
  max-width: 640px;
}
.actions-panel {
  margin-top: 20px;

  .vcv-button {
    letter-spacing: 0.01em;
    text-transform: uppercase;
    font-weight: 500;
  }
}

.profile-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}

.left-panel {
  width: 288px;
  display: flex;
  flex-direction: column;
  margin-right: 1.5rem;

  label.helper {
    display: block;
    color: $red-color;
    margin-bottom: 20px;
    font-weight: normal;
    padding-top: 5px;
  }
}

.right-panel {
  width: 100%;
  max-width: 444px;

  h3 {
    margin-top: 0;
    margin-bottom: 12px;
    font-style: normal;
    font-weight: bold;
    font-size: 17px;
    line-height: 24px;
    color: #233346;
  }

  .row-block {
    width: 100%;
    box-sizing: border-box;
    left: 0;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 4px;
    line-height: normal;
    position: relative;

    label {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #233346;
      margin-bottom: 0;
    }

    input,
    .my-profile-form__city-container {
      width: 100%;
    }

    .input-wrapper {
      width: 100%;

      input {
        width: 100%;
      }
    }

    & + h3 {
      margin-top: 32px;
    }

    &::v-deep {
      .city-select_custom.multiselect.big {
        width: 100%;
        max-width: none;
      }
    }
  }

  .row-block_btn {
    margin-top: 48px;
    display: flex;
    justify-content: flex-end;
  }
}

.phone-input {
  width: 100%;
}

.expressInvite {
  margin-top: 40px;
  padding: 20px 0;
  display: flex;
  align-items: center;
  border-top: 1px solid $light-grey-color;

  &__link {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    background-color: $green;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    color: #fff;
    margin-right: 20px;
    cursor: pointer;
    user-select: none;
    border: 0;
    text-decoration: none;

    &:hover {
      color: #fff;
      background-color: $green-hover;
    }

    &:focus {
      outline: none;
      color: #fff;
      box-shadow: 0px 0px 0px 1px #fff, 0px 0px 0px 2px #437aee;
    }
  }

  &__info {
    font-size: 16px;
    color: #333;
  }
}

.locale-selector {
  width: 80%;
  border-radius: 4px;
}

.modal-footer {
  display: flex;
  justify-content: flex-start;

  .vbutton {
    margin-left: 0;

    &.left {
      margin-right: auto;
    }
  }

  .vbutton + .vbutton {
    margin-left: 20px;
  }
}

.expressInvite__info {
  flex: 1;
}

.settings-company__dragDrop {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-size: 14px;
  color: #afafaf;
  cursor: pointer;
  transition: background-color 0.7s;
  border: 1px dashed $green;
  border-radius: 2px;
  color: $green;
  box-sizing: border-box;
  height: 288px;
  width: 288px;

  &.has-files {
    max-height: 288px;
    height: auto;
  }

  &:hover {
    border-style: solid;
  }

  & input.settings-company__dragDrop-input {
    opacity: 0;
    top: 0;
    left: 0;
    width: 100%;
    position: absolute;
    z-index: 10;
    cursor: pointer;

    &#file {
      height: 100%;
    }
  }

  img {
    max-height: 288px;
    height: auto;
    max-width: 288px;
    width: auto;
  }
}

.settings-company__image {
  max-width: 288px;
  margin-right: 25px;
}

.settings-company__dragDrop-image {
  margin-bottom: 4px;
}

.settings-company__upload-input {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: -1;
}

.upload__description {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dragDrop-descr {
  max-width: 184px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dragDrop-descr_title {
  margin-bottom: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: $green;
}

.dragDrop-descr_note {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #9faab6;
}

.upload__image {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.has-files {
  border: 1px solid #e5e5e5;

  .upload__description {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    background-color: #fff;
    // transition: background-color linear .3s;
    opacity: 0;
  }

  &:hover {
    color: #fff;

    .upload__description {
      opacity: 1;
      z-index: 1;
      background-color: rgba(127, 127, 127, 0.8);
    }
  }
}

.settings-company__upload-label {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 20px;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@/styles/variables.scss';

.vue-image-crop-upload .vicp-wrap {
  width: 600px !important;
}

.vicp-preview-item:nth-child(1) {
  display: none;
}

vicp-preview-item img {
  width: 140px;
  height: 140px;
}

.vue-image-crop-upload .vicp-wrap .vicp-operate a {
  font-size: 16px;
  width: 140px !important;
  font-weight: bold;
  // font-family: Roboto;
  background-color: $green;
  color: white !important;
  border-radius: 18px !important;
  text-transform: uppercase;
  border: 1px solid $green;
}

.vue-image-crop-upload .vicp-wrap .vicp-operate a:hover {
  background-color: #fff !important;
  color: #666 !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview {
  height: 212px;
}

.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-right
  .vicp-preview
  .vicp-preview-item
  span {
  padding-left: inherit;
}

.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-right
  .vicp-preview
  .vicp-preview-item:nth-child(2)
  img {
  width: 150px !important;
  height: 150px !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right {
  padding-right: 115px;
  padding-top: 50px;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview {
  overflow: unset !important;
}

.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-right
  .vicp-preview
  .vicp-preview-item
  span {
  bottom: -50px !important;
  font-size: 16px !important;
  padding-left: 10px !important;
}

.expressInvite__link {
  background-color: #fff !important;
  color: #232323 !important;
  border: 1px solid #d2d6e0 !important;
  border-radius: 2px !important;
}
</style>
